// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ml-6";
export var imgContainer = "_ml-3";
export var menuIcon = "_ml-5";
export var pillWrapper = "_ml-2";
export var pillsContainer = "_ml-1";
export var subscriptionCard = "_ml-0";
export var subscriptionLogo = "_ml-4";